import { render } from "./stelline.vue?vue&type=template&id=6ea2e1bf&scoped=true&ts=true"
import script from "./stelline.vue?vue&type=script&lang=ts"
export * from "./stelline.vue?vue&type=script&lang=ts"

import "./stelline.vue?vue&type=style&index=0&id=6ea2e1bf&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea2e1bf"]])

export default __exports__